import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';


import { adminDashboard, generateDataGraph } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { Chart, registerables } from 'chart.js';

import Progressbar from "./ProgressBar.js";

import AmCharts from "@amcharts/amcharts3-react";

const doughnutPieOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          }
        };    

const optionsN = {
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            }
        }],

    }
}

class partnerDashboardV1 extends Component {

    constructor(props) {
        super(props);
        this.state = {
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          school_data: [],
          allowedtoacess:false,
          clickedEnqG:false,
          clickedRevG:false,
          clickedProfCompl:false
        };

        this.LoadGrpah = this.LoadGrpah.bind(this);
    }

    componentDidMount() {

        let dataOfUser = this.state.auth_data;
        let allowedtoacess = (dataOfUser.upgraded==1)?true:(dataOfUser.current_plan!=5 && dataOfUser.current_plan!=0 && dataOfUser.current_plan!=1)?true:false;

        let req = {
            url: 'school_data'
        };

        adminDashboard(JSON.stringify(req)).then(response => {
            if (response.status === 1) {
                this.setSchoolChart(response.result);
            }
        });
      
        this.setState({allowedtoacess:allowedtoacess, user_name:this.state.auth_data.user_name, role:this.state.auth_data.role});   


        req.url = 'like_follow_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setLike(response.result);
            }
        });


        req.url = 'vistors_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setVisitors(response.result);
            }
        });


    }

    LoadGrpah(whichgraph){

      let dataOfUser = this.state.auth_data;

      let req = {
        vendor_id:dataOfUser.login_id,
        graph: whichgraph
      };

      if(whichgraph=='enq'){

      generateDataGraph(JSON.stringify(req)).then(response => {

        if (response.status === 1) {
            //only text graph
            this.setState({
                clickedEnqG:true,
                subtitle : response.graph_data.title,
                value:response.graph_data.value,
                label:response.graph_data.label
            });
        }
      });
    
    }

    if(whichgraph=='rev'){

      generateDataGraph(JSON.stringify(req)).then(response => {

          if (response.status === 1) {
            this.setState({clickedRevG:true, datasets:response.result.datasets});
             
          }

      });
      
    }  

    if(whichgraph=='profile'){

      this.setState({clickedProfCompl:true});

      /*
      generateDataGraph(JSON.stringify(req)).then(response => {

          if (response.status === 1) {
            this.setState({clickedProfCompl:true, datasets:response.result.datasets});
             
          }

      });
      */

      
      
    }  

    

    }

    
    setReviewGraphs = (data) => {

      var ctx = document.getElementById('barChartReviews');
      var myChart = new Chart(ctx, {
          type: 'bar',
          data: data,
          options: optionsN
      });
    } 

    setVisitors = (data) => {

        var ctx = document.getElementById('barChartVisitors');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }    

    setLike = (data) => {

        var ctx = document.getElementById('barChartLikeFollows');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }

    setAfterschoolChart = (data) => {

        var ctx = document.getElementById('afterschoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }    

    setTuitionChart = (data) => {

        var ctx = document.getElementById('tuitionChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setSchoolChart = (data) => {

        var ctx = document.getElementById('schoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setPreschoolChart = (data) => {

        var ctx = document.getElementById('preschoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    } 


    setcampChart = (data) => {

        var ctx = document.getElementById('campChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setcommunityChart = (data) => {

        var ctx = document.getElementById('communityChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setbirthdayChart = (data) => {

        var ctx = document.getElementById('birthdayChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }        


    render() {


      const config_donut = {
        "type": "pie",
        "theme": "none",
        "dataProvider": this.state.datasets,
        "valueField": "value",
        "titleField": "label",
        "outlineAlpha": 0.4,
        "depth3D": 15,
        "balloonText": "[[title]]<br><span style='font-size:14px'><b>[[value]]</b></span>",
        "angle": 30,
        "export": {
          "enabled": true
        }
                }

        return (
          <React.Fragment>
          <AdminLayout>
                    
            <div class="row  mt-3">
           
             
              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                    <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'} >
                        <div class="d-flex flex-wrap justify-content-between">
                        <h4 class="card-title mb-3">Visitors</h4>
                        
                        </div>
                        <div class="row">
                        <div class="col-12">
                            <canvas id="barChartVisitors"></canvas>
                        </div>
                        </div>
                    </div>
                </div>
              </div>

             

              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                  <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'}>
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Likes & Follows</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <canvas id="barChartLikeFollows"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                  <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'}>
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Enquiries</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                          {this.state.clickedEnqG &&

                            <div class="graphbox">

                                  <div class="smalltitle">{this.state.subtitle}</div>
                                  <div class="bigvalue">{this.state.value}</div>
                                  <div class="linktogo"><a href={this.state.link} target='_blank'>Click here to view all</a></div>
                            </div>
                          
                          }
                          {!this.state.clickedEnqG &&

                            <div><button class="btn btn-primary btn-sm" onClick={()=>this.LoadGrpah("enq")}>Click to load</button></div>

                          }
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                  <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'}>
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Ratings</h4>
                      
                    </div>
                     
                    <div class="row">
                      <div class="col-12">
                          {this.state.clickedRevG &&

                            <div class="graphbox">
                                <AmCharts.React style={{ width: "100%", height: "500px" }} options={config_donut} />
                            </div>
                          
                          }
                          {!this.state.clickedRevG &&

                            <div><button class="btn btn-primary btn-sm" onClick={()=>this.LoadGrpah("rev")}>Click to load</button></div>

                          }
                      </div>
                    </div>

                  </div>
                </div>
              </div>


              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                  <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'}>
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Profile Completion</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                          {this.state.clickedProfCompl &&
                              <div>
                               <div>Account completion</div>
                               <Progressbar
                          bgcolor="orange"
                          progress="30"
                          height={30}
                          />

                          <div>Profile completion</div>
                          <Progressbar
                          bgcolor="red"
                          progress="60"
                          height={30}
                          />
                            </div> 
                          }
                          {!this.state.clickedProfCompl &&
                             <div><button class="btn btn-primary btn-sm" onClick={()=>this.LoadGrpah("profile")}>Click to load</button></div>
                          }
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                  <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'}>
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Fees (percentage view of your chosen category)  </h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                          
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              

            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default partnerDashboardV1;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/dashboardV1.jsx